var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");
var GradeLevel = require("lib/academic/GradeLevel");
var CurrentUser = require("lib/account/CurrentUser");
var Glyphicon = require("components/utility/icons/Glyphicon");
var UpgradeTokenForm = require("components/users/teachers/upgrade/UpgradeTokenForm");

class OnboardingStageGenericGradeLevel extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
		};
	}

	buildOnGradeSelectF(gradeLevel) {
		return () => {
			var adminID = CurrentUser.get().id;
			var adminData = { grade_level: gradeLevel };
			CurrentUser.api().patchAdmin(adminID, { admin: adminData }, $wr.apiHandler((response) => {
				CurrentUser.fetchCurrentUserData();
			}));

		this.props.onComplete({ gradeLevel: gradeLevel });

			Mycroft.newEvent({ category: "Onboarding", action: "grade-selected" });
		};
	}

	skipUpgradeCode() {
	}

	render() {
		var leftContent = (
			<div className="onboardingTestimonial">
				<img className="educatorImg" src={ require("onboarding/amy.png") } />
				<p className="educatorInfo">Amy Talvac | 3rd Grade Teacher</p>
				<div className="quote">
					<img className="quoteImg" src={ require("onboarding/quotes.png") } />
					<p className="quoteText">
						In my class, students are required to read for 20 minutes
						each day as a part of their daily homework. Whooo's Reading
						makes it easy for me to check on each student's progress.
					</p>
				</div>
			</div>
		);

		var gradeOptions = DropDownOptions.Button.Grades({
			buildOptionF: this.buildOnGradeSelectF
		});

		var gradeLevelDropdown = (
			<ButtonDropdown text="Choose" dropdownDisplay="button"
				className="gradePicker" buttonClassName="buttonPrimary">
				{ gradeOptions }
			</ButtonDropdown>
		);

		if (CurrentUser.get().product == "wrSolo") {

			var instructionsTitle = 'Upgrade or Referral Code:'
			var instructions = 'If you have an upgrade or referral code already, enter it. Otherwise, you can enter one later.'
		
			var upgradeForm = (
				<div className="subStage">
					<p className="onboardingInstructions">
						<span className="instructionTitle">
							{instructionsTitle}
						</span>
						{instructions}
					</p>

					<UpgradeTokenForm updateInPlace />
				</div>
			);
		}

		return (
			<div className="onboardingStage onboardingStageGenericGradeLevel clearfix">
				<div className="leftCol">
					{ leftContent }
				</div>

				<div className="gradeSelection rightCol">
					<p className="onboardingGreeting">
						Thank you for signing up!
					</p>

					{ upgradeForm }

					<div className="subStage">
						<p className="onboardingInstructions">
							<span className="instructionTitle">
								Grade Level:
							</span>

							Align Whooo's Reading to the right level. Pick one of the grades
							you teach.
						</p>
						{ gradeLevelDropdown }
						<p className="onboardingInstructions">
							If you teach multiple grade levels, don't worry! You can pick different
							grades for your students when you add them later.
						</p>
					</div>
				</div>

			</div>
		);
	}
}

OnboardingStageGenericGradeLevel.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	// only used for the final stage of onboarding
	endOnboarding: PropTypes.func,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageGenericGradeLevel;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageGenericGradeLevel.js